export enum FileInputStyle {
  regular,
  dashed,
}
